<template>
  <div>
    <div class="container-fluid">
      <div class="row">
        <div class="col-12">
          <div style="display: flex; justify-content: space-between; margin-top: 40px;">
            <div style="width: 100%;">
              <p class="light-blue" style="margin-bottom: 5px; font-size: 45px;">SUMMARY STATEMENT</p>
            </div>
            <div style="width: 0%;">
              <div style="text-align: center;">
              </div>
            </div>
            <div style="width: 50%; text-align: right;">
              <p class="dark-blue" style="margin-bottom: 5px; font-size: 25px;">
                {{ date ? moment(date).format('DD/MM/YYYY') : '' }}
              </p>
            </div>
          </div>
          <div class="pt-3" style="width: 100%; display: flex; justify-content: space-between;">
            <div>
              <p v-if="business.agency" class="text-header dark-blue pl-0">{{ business.agency.name }}</p>
              <p v-if="business.agency" class="text-header main-color pl-0">{{ business.agency.address }}</p>
            </div>
            <div class="bg-light-grey" style="text-align: right; padding: 5px;">
              <p v-if="business.agency" class="text-section shippori dark-blue">{{ business.name }}</p>
              <p v-if="business.agency" class="text-section main-color">{{ business.address }}</p>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="container-fluid" style="page-break-after: always;">
      <div class="row">
        <div class="col-12">
          <table class="principal bordered" style="margin-top: 30px; width: 100%;">
            <thead style="color: #ffffff; text-align: center;">
              <tr>
                <th class="bg-light-blue white">BSA #</th>
                <th class="bg-light-blue white">BSA DATE</th>
                <th class="bg-light-blue white">AGENCY REFERENCE</th>
                <th class="bg-light-blue white">DOF</th>
                <th class="bg-light-blue white">LIVESTOCK TYPE</th>
                <th class="bg-light-blue white">OPEN HEAD</th>
                <th class="bg-light-blue white">BALANCE</th>
              </tr>
            </thead>
            <tbody v-if="statement.extra_attributes" style="text-align: center;">
              <tr v-for="purchase in statement.extra_attributes.detailed" :key="purchase.id"
                :class="expiresInOneMonth(purchase.purchase)">
                <td>{{ purchase.purchase.ref_id }}</td>
                <td>{{
                  purchase.purchase.invoice_invoice_date ?
                  moment(purchase.purchase.invoice_invoice_date).format('DD.MM.YYYY') : ''
                }}</td>
                <td>{{ purchase.purchase.reference_code }}</td>
                <td>
                  {{ purchase.purchase.balance_as_of_date ? purchase.purchase.balance_as_of_date.day : 0 }}
                </td>
                <td>{{ purchase.purchase.livestock_class.name }}</td>
                <td>
                  {{
                    purchase.purchase.balance_as_of_date ? purchase.purchase.balance_as_of_date.livestock_head_on_hand
                    : 0
                  }}
                </td>
                <td
                  v-if="purchase.purchase.balance_as_of_date && [-0.02, 0.02, 0.01].includes(_.round(purchase.purchase.balance_as_of_date.contract_balance_inc_gst, 2))">
                  $0.00</td>
                <td v-else>
                  {{
                    formatValueCurrency(purchase.purchase.balance_as_of_date ?
                      _.round(purchase.purchase.balance_as_of_date.contract_balance_inc_gst, 2) : 0)
                  }}
                </td>
              </tr>
              <tr class="dark-blue extra" style="border-top: 1px solid #25405d;">
                <td class="bg-light-grey extra" colspan="5" style="text-align: right;">
                  Outstanding Balance as at {{ moment(date).format('DD/MM/YYYY') }}:</td>
                <td class="bg-light-grey extra">
                  {{ headTotal() }}
                </td>
                <td class="bg-light-grey extra">
                  {{ formatValueCurrency(_.round(totalBalance(), 2)) }}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <div class="row pt-3 pl-4">
        <p style="font-size: 16px;">* Statement is inclusive of GST</p>
      </div>
      <div class="row pt-3 pl-4">
        <p style=" color: #0a337b; font-size: 16px;">
          For a formalised payout figure please contact Ottley Capital at <a
            href="admin@ottleycapital.com">admin@ottleycapital.com</a>
        </p>
      </div>
    </div>

    <individual-statement v-for="(item, index) in statement.extra_attributes.detailed" :key="item.id" :item="item"
      :statement="statement" :date="date" :business="business" :header-img="headerImg"
      :last-in-loop="index == item.length - 1" />
  </div>
</template>

<script>
export default {
  props: {
    statementId: {
      type: Number | String,
      required: true
    },
    headerImg: {
      type: String
    },
    signature: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      statement: {},
      business: {},
      date: null,
      totalBalanceStack: [],
      headTotalStack: [],
    }
  },
  mounted() {
    this.getGroupStatements();
  },
  methods: {
    expiresInOneMonth(purchase) {
      let openHead = purchase.balance_as_of_date ? purchase.balance_as_of_date.livestock_head_on_hand : 0;
      let expiry = moment(purchase.invoice_due_date);
      let datePlusOneMonth = moment(this.date).clone().add(1, 'M');
      if (expiry.isBefore(datePlusOneMonth) && expiry.isBetween(moment(this.date), datePlusOneMonth)
        && (openHead > 0 && purchase.balance_as_of_date.contract_balance_inc_gst > 0.1)
      )
        return 'red-badge';
      return '';
    },
    getGroupStatements() {
      this.loading = true;
      axios.get(this.signature)
        .then(res => {
          this.date = res.data.date;
          this.business = res.data.business;
          this.statement = res.data.statement;
        })
        .finally(() => {
          this.loading = false;
        });
    },
    calculateHeadTotal(value) {
      this.headTotalStack.push(value);
      return value;
    },
    calculateRowBalance(value) {
      this.totalBalanceStack.push(value);
      return value;
    },
    formatValueCurrency(value) {
      return Number(value).toLocaleString('en-AU', { style: 'currency', currency: 'AUD' });
    },
    headTotal() {
      return this.statement.extra_attributes.detailed.reduce((acc, curr) => {
        return acc + (curr.purchase.balance_as_of_date ? curr.purchase.balance_as_of_date.livestock_head_on_hand : 0)
      }, 0);
    },
    totalBalance() {
      return this.statement.extra_attributes.detailed.reduce((acc, curr) => {
        return acc + (curr.purchase.balance_as_of_date ? _.round(curr.purchase.balance_as_of_date.contract_balance_inc_gst, 2) : 0)
      }, 0);
    }
  }
}
</script>

<style scoped>
.red-badge td {
  background-color: #f5b0b0;
  color: #fff;
}
</style>
